"use strict";

angular.module('rmEPG')
    .factory('Broadcast', require('./broadcast.js'))
    .factory('BroadcastRepetition', require('./broadcastrepetition.js'))
    .factory('Item', require('./item.js'));
